import {useContext} from 'react';

import {DataGridFiltersModelContext} from './DataGridFiltersModelContext';

export const useDataGridFiltersModel = () => useContext(DataGridFiltersModelContext);
